import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./i18n.ts";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./apollo/apolloClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </Provider>
);
